<template>
    <v-container fluid class="pa-0">

        <swiper ref="mySwiper" :options="swiperOptions">
            <!--             <swiper-slide>
                <v-card max-width="100%" class="mx-auto">
                    <v-img :aspect-ratio="15.9235/10" :width="width" :src="src1"></v-img>
                    <div class="pa-5 card-body">
                        <p class="title" style="line-height:1.2em;">NAKED 花つくばい</p>
                        <p align="left" class="caption">
                            手を清める手指消毒アートコンテンツ。手を差し出すと、アルコールが手に噴射されると共に、様々な花が咲き乱れ舞い散ります。
                        </p>
                    </div>
                </v-card>
            </swiper-slide> -->
            <swiper-slide>
                <v-card max-width="100%" class="mx-auto" dark>
                    <v-img :aspect-ratio="15.9235/10" :width="width" :src="kaleido"></v-img>
                    <div class="pa-5 card-body">
                        <p class="title" style="line-height:1.2em;">「KALEIDO JELLYFISH」<br><small>by Ryotaro Muramatsu /
                                NAKED</small></p>
                        <p align="left" class="caption">
                            クラゲをモチーフとした、村松亮太郎のアート。その曖昧で神々しい自動生成を繰り返すモザイクが描くクラゲの姿に自分の意識を委ね、心を鎮める。
                        </p>
                    </div>
                </v-card>
            </swiper-slide>
            <swiper-slide>
                <v-card max-width="100%" class="mx-auto">
                    <v-img :aspect-ratio="15.9235/10" :width="width" :src="sanitized"></v-img>
                    <div class="pa-5 card-body">
                        <p class="title" style="line-height:1.2em;">コロナ対策アート「CLEAN JUNGLE」</p>
                        <p align="left" class="caption">
                            扉を開き、まるでジャングルの 奥地にいるシャーマンに会いにいくようなジャングリーな道を通り抜けながら、 ユーカリやティーツリーなどが配合された抗菌 ・抗ウイルス 効果が期
                            待できるアロマで、心身ともに清める。
                        </p>
                        <v-card-actions>
                        </v-card-actions>
                    </div>
                </v-card>
            </swiper-slide>
            <swiper-slide>
                <v-card max-width="100%" class="mx-auto">
                    <v-img :aspect-ratio="15.9235/10" :width="width" :src="horoscope"></v-img>
                    <div class="pa-5 card-body">
                        <p class="title" style="line-height:1.2em;">「HOROSCOPE」／占法：西洋占星術</p>
                        <p align="left" class="caption">
                            12星座の世界に360度没入する異空間。自分の中にある12星座 の物語を感じ、自分の魂がホロスコープに込めた自分の本質と向き合う。自分の今世で目指す姿を現す太 陽星座
                            の扉に立つと、その星座 の世界が出現 。体験と連動する公式サイトのマイページでは、真木あかりによるホロスコープ主要10天体から分かる各々の資質の鑑定結果を保存し、見返すことも可能。
                        </p>
                        <v-card-actions>
                        </v-card-actions>
                    </div>
                </v-card>
            </swiper-slide>
            <swiper-slide>
                <v-card max-width="100%" class="mx-auto">
                    <v-img :aspect-ratio="15.9235/10" :width="width" :src="tarot"></v-img>
                    <div class="pa-5 card-body">
                        <p class="title" style="line-height:1.2em;">「TAROT」／占法：タロットカード</p>
                        <p align="left" class="caption">
                            潜在意識 から 顕在意識 まで自らの状態 を知るタロットの部屋 。席につくと、タロットの神秘 的な世界観がクラシカルなアロマの香りとともに出現 。自ら 選ん
                            だタロットカード1枚で、今の自分に必要 なメッセージを引き寄せ る。また、過去 ・現在・未来を占うスリーカード・オラクル体験では、これからの運命 を自ら 切り開くために、自分の潜在意識
                            が描こうとする未来を把握 する。鑑定結果は公式サイトのマイページにて保存可能。
                        </p>
                        <v-card-actions>
                        </v-card-actions>
                    </div>
                </v-card>
            </swiper-slide>
            <swiper-slide>
                <v-card max-width="100%" class="mx-auto">
                    <v-img :aspect-ratio="15.9235/10" :width="width" :src="dreamin"></v-img>
                    <div class="pa-5 card-body">
                        <p class="title" style="line-height:1.2em;">「DREAMIN’ LUCY」／占法：夢診断</p>
                        <p align="left" class="caption">
                            その人の深層 心理が 反映
                            されるという夢。村松亮太郎のAI（人工知能）アート「LUCY」が占い師となり、体験者の脳へコネクト。よく見る夢や昨日見た夢、気になる夢など、夢診断を通して、体験者ごとの 深層
                            心理が、AIでリアルタイムに生成 される
                            一期一会のAIアート体験。公式サイトのマイページでは、夢診断AIユニットSOL-minorによる「ユメカルテ」（約300文字～400文字）も発行。<br>
                            <a href="https://www.sol-minor.com/" target="_blank" style="color:white;">Powered by SOL-minor夢診断AI</a>
                        </p>
                        <v-card-actions>
                        </v-card-actions>
                    </div>
                </v-card>
            </swiper-slide>
            <swiper-slide>
                <v-card max-width="100%" class="mx-auto">
                    <v-img :aspect-ratio="15.9235/10" :width="width" :src="suhi"></v-img>
                    <div class="pa-5 card-body">
                        <p class="title" style="line-height:1.2em;">「NUMEROLOGY THERAPY」／占法：数秘術</p>
                        <p align="left" class="caption">
                            生年月日で算出する数秘術から導き出された自らのパーソナルナンバーがプロジェクションマッピングで出現。パーソナルナンバーに基づくフラワーエッセンスで癒され、自分のパーソナルナンバーに基づく色の効果で、自分の資質をエンパワーメント。鑑定結果はオンラインサイトのマイページにて保存可能。
                        </p>
                        <!--                     <v-card-actions>
                            <v-btn text>もっと見る</v-btn>
                        </v-card-actions>
                         -->
                    </div>
                </v-card>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>

    </v-container>
</template>


<script>
    import {
        Swiper,
        SwiperSlide,
        directive
    } from 'vue-awesome-swiper'


    export default {
        components: {
            Swiper,
            SwiperSlide
        },
        directives: {
            swiper: directive
        },

        data() {
            return {
                swiperOptions: {
                    loop: false, //無限ループ
                    spaceBetween: 18, //余白
                    centeredSlides: true, //センター表示
                    clickable: false, //クリック
                    initialSlide: '0',
                    pagination: { //ページネーション
                        el: '.swiper-pagination'
                    },
                    slidesPerView: 4.2,
                    breakpoints: {
                        1024: {
                            slidesPerView: 3.2,
                            spaceBetween: 40
                        },
                        768: {
                            slidesPerView: 2.2,
                            spaceBetween: 30
                        },
                        640: {
                            slidesPerView: 2.2,
                            spaceBetween: 20
                        },
                        320: {
                            slidesPerView: 1.3,
                            spaceBetween: 16
                        }
                    }
                    // Some Swiper option/callback...
                },
      // コンテンツ情報

        kaleido: './Images/contents/URANAI_JellyFish_0615_fin_s_1500w.jpg',
        sanitized: './Images/contents/URANAI_SanetizedArt_0618_fin_s_1500w.jpg',
        horoscope: './Images/contents/horoscope_c.jpg',
        tarot: './Images/contents/tarot_c.jpg',
        dreamin: './Images/contents/dreamin-lucy_c.jpg',
        suhi: './Images/contents/numerology_c.jpg',
            }
        },


    }
</script>

<style lang="scss" scoped>
    .swiper-container {
        width: 100%;
        //        height: 700px !important;
        padding-bottom: 50px;
    }

    .swiper-slide {
        background: inherit;
        color: #666;
        font-size: 24px;
        display: flex;
        height: auto;
        justify-content: center;
        align-items: flex-start;

        .v-card {
            height: 100%;
            background: rgb(186, 78, 213);
            background: linear-gradient(176deg, rgba(186, 78, 213, 1) 0%, rgba(165, 90, 230, 1) 46%, rgba(22, 162, 190, 1) 100%);
        }
    }


    .swiper-slide {

        .v-image {
            background-position: center;
            background-size: cover;
        }
    }
</style>